export default "__VITE_ASSET__CSednqSs__"